import script from "./GeneralApplicationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneralApplicationForm.vue?vue&type=script&setup=true&lang=js"

import "./GeneralApplicationForm.vue?vue&type=style&index=0&id=dac65194&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dac65194"]])

export default __exports__